export default __webpack_public_path__ + "static/media/achyuth.ff456361.png";